import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { forwardRef, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from 'ngx-color';
import { ColorWrap, isValidHex, SwatchModule, EditableInputModule } from 'ngx-color';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
const _c0 = a0 => ({
  input: a0
});
function TwitterComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "color-swatch", 7);
    i0.ɵɵlistener("onClick", function TwitterComponent_For_5_Template_color_swatch_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleBlockChange($event));
    })("onHover", function TwitterComponent_For_5_Template_color_swatch_onHover_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSwatchHover.emit($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const color_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(ctx_r1.swatchStyle);
    i0.ɵɵproperty("color", color_r3)("focusStyle", ctx_r1.focus(color_r3));
  }
}
class TwitterComponent extends ColorWrap {
  /** Pixel value for picker width */
  width = 276;
  /** Color squares to display */
  colors = ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'];
  triangle = 'top-left';
  swatchStyle = {
    width: '30px',
    height: '30px',
    borderRadius: '4px',
    fontSize: '0'
  };
  input = {
    borderRadius: '4px',
    borderBottomLeftRadius: '0',
    borderTopLeftRadius: '0',
    border: '1px solid #e6ecf0',
    boxSizing: 'border-box',
    display: 'inline',
    fontSize: '14px',
    height: '30px',
    padding: '0',
    paddingLeft: '6px',
    width: '100%',
    color: '#657786'
  };
  disableAlpha = true;
  constructor() {
    super();
  }
  focus(color) {
    return {
      boxShadow: `0 0 4px ${color}`
    };
  }
  handleBlockChange({
    hex,
    $event
  }) {
    if (isValidHex(hex)) {
      // this.hex = hex;
      this.handleChange({
        hex,
        source: 'hex'
      }, $event);
    }
  }
  handleValueChange({
    data,
    $event
  }) {
    this.handleBlockChange({
      hex: data,
      $event
    });
  }
  static ɵfac = function TwitterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TwitterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TwitterComponent,
    selectors: [["color-twitter"]],
    inputs: {
      width: "width",
      colors: "colors",
      triangle: "triangle"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TwitterComponent),
      multi: true
    }, {
      provide: ColorWrap,
      useExisting: forwardRef(() => TwitterComponent)
    }]), i0.ɵɵInheritDefinitionFeature],
    decls: 11,
    vars: 11,
    consts: [[1, "triangleShadow"], [1, "triangle"], [1, "twitter-body"], [1, "twitter-swatch"], [1, "twitter-hash"], [1, "twitter-input"], [3, "onChange", "value"], [3, "onClick", "onHover", "color", "focusStyle"]],
    template: function TwitterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵelement(1, "div", 0)(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵrepeaterCreate(4, TwitterComponent_For_5_Template, 2, 4, "div", 3, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementStart(6, "div", 4)(7, "div");
        i0.ɵɵtext(8, "#");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 5)(10, "color-editable-input", 6);
        i0.ɵɵlistener("onChange", function TwitterComponent_Template_color_editable_input_onChange_10_listener($event) {
          return ctx.handleValueChange($event);
        });
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵclassMapInterpolate2("twitter-picker ", ctx.triangle, "-triangle ", ctx.className, "");
        i0.ɵɵstyleProp("width", ctx.width, "px");
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.colors);
        i0.ɵɵadvance(6);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(9, _c0, ctx.input));
        i0.ɵɵproperty("value", ctx.hex.replace("#", ""));
      }
    },
    dependencies: [i1.SwatchComponent, i1.EditableInputComponent],
    styles: [".twitter-picker[_ngcontent-%COMP%]{background:#fff;border:0px solid rgba(0,0,0,.25);box-shadow:#00000040 0 1px 4px;border-radius:4px;position:relative;box-sizing:border-box}.triangleShadow[_ngcontent-%COMP%]{width:0px;height:0px;border-style:solid;border-width:0px 9px 10px;border-color:transparent transparent rgba(0,0,0,.1);position:absolute}.triangle[_ngcontent-%COMP%]{width:0px;height:0px;border-style:solid;border-width:0px 9px 10px;border-color:transparent transparent rgb(255,255,255);position:absolute}.hide-triangle[_ngcontent-%COMP%] > .triangle[_ngcontent-%COMP%]{display:none}.hide-triangle[_ngcontent-%COMP%] > .triangleShadow[_ngcontent-%COMP%]{display:none}.top-left-triangle[_ngcontent-%COMP%] > .triangle[_ngcontent-%COMP%]{top:-10px;left:12px}.top-left-triangle[_ngcontent-%COMP%] > .triangleShadow[_ngcontent-%COMP%]{top:-11px;left:12px}.top-right-triangle[_ngcontent-%COMP%] > .triangle[_ngcontent-%COMP%]{top:-10px;right:12px}.top-right-triangle[_ngcontent-%COMP%] > .triangleShadow[_ngcontent-%COMP%]{top:-11px;right:12px}.twitter-body[_ngcontent-%COMP%]{padding:15px 9px 9px 15px}.twitter-swatch[_ngcontent-%COMP%]{width:30px;height:30px;display:inline-block;margin:0 6px 0 0}.twitter-hash[_ngcontent-%COMP%]{background:#f0f0f0;height:30px;width:30px;border-radius:4px 0 0 4px;color:#98a1a4;margin-left:-3px;display:inline-block}.twitter-hash[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:absolute;align-items:center;justify-content:center;height:30px;width:30px;display:flex}.twitter-input[_ngcontent-%COMP%]{display:inline-block;margin-top:-6px;font-size:10px;height:27px;padding:0;position:relative;top:6px;vertical-align:top;width:108px;margin-left:-4px}"],
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TwitterComponent, [{
    type: Component,
    args: [{
      selector: 'color-twitter',
      template: `
    <div class="twitter-picker {{ triangle }}-triangle {{ className }}" [style.width.px]="width">
      <div class="triangleShadow"></div>
      <div class="triangle"></div>
      <div class="twitter-body">
        @for (color of colors; track color) {
          <div class="twitter-swatch">
            <color-swatch
              [color]="color"
              [style]="swatchStyle"
              [focusStyle]="focus(color)"
              (onClick)="handleBlockChange($event)"
              (onHover)="onSwatchHover.emit($event)"
            ></color-swatch>
          </div>
        }
        <div class="twitter-hash">
          <div>#</div>
        </div>
        <div class="twitter-input">
          <color-editable-input
            [style]="{ input: input }"
            [value]="hex.replace('#', '')"
            (onChange)="handleValueChange($event)"
          ></color-editable-input>
        </div>
      </div>
    </div>
  `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      preserveWhitespaces: false,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TwitterComponent),
        multi: true
      }, {
        provide: ColorWrap,
        useExisting: forwardRef(() => TwitterComponent)
      }],
      standalone: false,
      styles: [".twitter-picker{background:#fff;border:0px solid rgba(0,0,0,.25);box-shadow:#00000040 0 1px 4px;border-radius:4px;position:relative;box-sizing:border-box}.triangleShadow{width:0px;height:0px;border-style:solid;border-width:0px 9px 10px;border-color:transparent transparent rgba(0,0,0,.1);position:absolute}.triangle{width:0px;height:0px;border-style:solid;border-width:0px 9px 10px;border-color:transparent transparent rgb(255,255,255);position:absolute}.hide-triangle>.triangle{display:none}.hide-triangle>.triangleShadow{display:none}.top-left-triangle>.triangle{top:-10px;left:12px}.top-left-triangle>.triangleShadow{top:-11px;left:12px}.top-right-triangle>.triangle{top:-10px;right:12px}.top-right-triangle>.triangleShadow{top:-11px;right:12px}.twitter-body{padding:15px 9px 9px 15px}.twitter-swatch{width:30px;height:30px;display:inline-block;margin:0 6px 0 0}.twitter-hash{background:#f0f0f0;height:30px;width:30px;border-radius:4px 0 0 4px;color:#98a1a4;margin-left:-3px;display:inline-block}.twitter-hash>div{position:absolute;align-items:center;justify-content:center;height:30px;width:30px;display:flex}.twitter-input{display:inline-block;margin-top:-6px;font-size:10px;height:27px;padding:0;position:relative;top:6px;vertical-align:top;width:108px;margin-left:-4px}\n"]
    }]
  }], () => [], {
    width: [{
      type: Input
    }],
    colors: [{
      type: Input
    }],
    triangle: [{
      type: Input
    }]
  });
})();
class ColorTwitterModule {
  static ɵfac = function ColorTwitterModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColorTwitterModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ColorTwitterModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, SwatchModule, EditableInputModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorTwitterModule, [{
    type: NgModule,
    args: [{
      declarations: [TwitterComponent],
      exports: [TwitterComponent],
      imports: [CommonModule, SwatchModule, EditableInputModule]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ColorTwitterModule, TwitterComponent };
